import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hydration-requirement-form"
export default class extends Controller {
  static targets = [
    "defaultValueModeSelectInput",
    "defaultValueTextareaWrapper",
    "defaultValueTextareaInput",
    "defaultValueSourceSelectWrapper",
    "defaultValueSourceSelectInput"
  ]

  connect() {
    // On form views, adjust visibility immediately.
    this.modeSelected()
  }

  modeSelected() {
    const mode = this.hasDefaultValueModeSelectInputTarget
      ? (this.defaultValueModeSelectInputTarget.value || "").toString()
      : ""

    if (mode === "static") {
      this.show(this.defaultValueTextareaWrapperTarget)
      this.hide(this.defaultValueSourceSelectWrapperTarget)
      this.clear(this.defaultValueSourceSelectInputTarget)
    } else if (mode === "derived") {
      this.hide(this.defaultValueTextareaWrapperTarget)
      this.clear(this.defaultValueTextareaInputTarget)
      this.show(this.defaultValueSourceSelectWrapperTarget)
    } else {
      // no_default or any other/blank value
      this.hide(this.defaultValueTextareaWrapperTarget)
      this.hide(this.defaultValueSourceSelectWrapperTarget)
      this.clear(this.defaultValueTextareaInputTarget)
      this.clear(this.defaultValueSourceSelectInputTarget)
    }
  }

  show(el) { if (el) el.classList.remove("hidden") }
  hide(el) { if (el) el.classList.add("hidden") }

  clear(el) {
    if (!el) return
    if (el.tagName === "SELECT") {
      el.value = ""
    } else {
      el.value = ""
    }
    el.dispatchEvent(new Event("input", { bubbles: true }))
    el.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
